import ViewReverse from '../ViewReverse';
import images from '../../constants/images';
import { cn } from '../../utils/utils';
import AuthContainerFunctional from './index.function';
import { Text } from '../SecondaryMarket';
import { fontSizes } from '../../constants/constants';
import Language from '../Language';

const AuthContainer = ({ children, className }) => {
  const { isArabic, TextWeight, getContentKey } = AuthContainerFunctional();

  return (
    <ViewReverse className='h-screen'>
      <div
        className={cn(
          'w-1/2 bg-cover bg-no-repeat bg-bottom hidden md:flex flex-col justify-between px-8 pt-8 pb-14',
          isArabic ? 'items-end' : 'items-start',
        )}
        style={{
          backgroundImage: `url(${images.auth_bg})`,
        }}
      >
        <img src={images.logo_white} className='h-14 w-14' />

        <Text
          text={getContentKey('welcome_account_application')}
          size={fontSizes.h45}
          weight={TextWeight.headingBold}
          className={'leading-[50px] w-3/5 text-white'}
        />
      </div>
      <div className='flex flex-col w-full md:w-1/2 flex-1 overflow-y-auto relative'>
        <ViewReverse className={cn('justify-end gap-6 fixed z-10 top-0 w-full md:w-1/2 bg-white', isArabic ? 'left-0' : 'right-0')}>
          <Language />
          <img src={images.logo} width={80} />
        </ViewReverse>

        <div className='flex-1 flex flex-col justify-center items-center mt-14'>
          <div className={className}>{children}</div>
        </div>
      </div>
    </ViewReverse>
  );
};

export default AuthContainer;
